import { defineStore } from 'pinia'
import { PAGE_LENGTH } from "@/const/pagenate";

// 検索条件store
export const useSearchParamStore = defineStore({
    id: "mSearchParam",
    state: () => {
        return {
            searchParam: {} as PurchaseType.PurchaseParam,
            isSearched: false,
            savedPageLength: PAGE_LENGTH
        }
    },
    actions: {
        // 検索条件設定
        setSearchParam(param: PurchaseType.PurchaseParam, length: number) {
            this.searchParam = param
            this.isSearched = true
            this.savedPageLength = length
        },
        // 検索条件クリア
        clearSearchParam() {
            this.searchParam = {
                statusCode: [],
                mournerName: null,
                orderDateFrom: null,
                orderDateTo: null,
                deliveryDateFrom: null,
                deliveryDateTo: null,
                ceremonyDateFrom: null,
                ceremonyDateTo: null,
                personName: null,
                deliveryPlace: null,
                isComplete: false,
                limit: null,
                offset: null,
                top: null
            }
            this.isSearched = false
        }
    },
    // データの永続化(セッション単位)
    persist: {
        enabled: true,
        strategies: [
            {
                storage: sessionStorage
            }
        ]
    }
})

